export default "__VITE_ASSET__SrAEY_nu__"